<template>
  <AppContainer justify-center>
    <div class="text-center">
      <EHeroContent
        icon="hourglass-clock"
        variant="success"
        :title="t(useTranslationPath(callerPath, 'title'))"
        :description="t(useTranslationPath(callerPath, 'description'))"
      >
        <template v-if="!forceApproval" #action>
          <div class="mt-8">
            {{ t(useTranslationPath(callerPath, 'nonForceApproval')) }}
          </div>
          <EButton
            :label="t(useTranslationPath(callerPath, 'nonForceApprovalButtonLabel'))"
            @click="onContinue"
          />
        </template>
        <template v-else #action>
          <div class="mt-8">
            {{ t(useTranslationPath(callerPath, 'forceApproval')) }}
          </div>
        </template>
      </EHeroContent>
    </div>
  </AppContainer>
</template>

<script setup>
import AppContainer from '@/components/AppContainer.vue'
import { useGetConfigVar } from '@/composables/useGetConfigVar.js'
import { useLoginRedirect } from '@/composables/useLoginRedirect.js'
import { useTranslationPath } from '@/composables/useTranslationPath.js'
import { useAppStore } from '@/stores/AppStore.js'
import { EButton, EHeroContent } from '@expansivefm/eds'
import { inject, onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const appStore = useAppStore()
const axios = inject('$axios')
const { redirectToLogin } = useLoginRedirect(axios)
const callerPath = 'views.unauthenticated.verification.methods.confirmed'
const forceApproval = ref(null)

onMounted(async () => {
  appStore.showBackButton = false
  forceApproval.value = useGetConfigVar('ENGINEER_APP_FORCE_VERIFICATION_METHOD_APPROVAL')
})

const onContinue = async () => {
  await redirectToLogin()
}
</script>
